import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// withCredentials so the JWT cookie is sent — backend uses this to detect anon/free/paid tier.
const client = axios.create({ baseURL: API, withCredentials: true });

export const fetchPrograms = (params) => client.get(`/programs`, { params }).then((r) => r.data);
export const fetchProgram = (slug) => client.get(`/programs/${slug}`).then((r) => r.data);
export const fetchFeatured = () => client.get(`/programs/featured`).then((r) => r.data);
export const fetchCompare = (slugs) => client.get(`/programs/compare`, { params: { slugs: slugs.join(",") } }).then((r) => r.data);
export const fetchNiches = () => client.get(`/niches`).then((r) => r.data);
export const fetchNiche = (slug) => client.get(`/niches/${slug}`).then((r) => r.data);
export const fetchStats = () => client.get(`/stats`).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post(`/newsletter/subscribe`, { email }).then((r) => r.data);
export const trackJoinClick = (slug) => client.post(`/track/join-click`, { slug }).catch(() => {});
